import React, { useRef,useEffect,useState } from 'react'
 import { useStore } from './store'
import AppConfig from '../Home/Config.js';
import { useSpring, animated,useTrail } from 'react-spring';
import { Light } from 'three';
import { Howl, Howler } from 'howler';
import ReactHowler from 'react-howler';
import {useNavigate ,useLocation ,useSearchParams } from 'react-router-dom';
import { useGesture , useDrag} from '@use-gesture/react';
import './style.css';
import { Center } from '@react-three/drei';
const hostloca=AppConfig.cdnUrl;


let tempx=0
let candrag=true
let targetcard=0
let cardgroup=[1,0,0]
 
let bgcolorset=['#C8DBE9','#CACACA','#F2E1C7']


export default function Wallpaper(props) {

    const [cardbg,setcardbg]=useState(0) 
    const [wptop,setwptop]=useState(0) 
    const [wppose,setwppose]=useState([[0,'0%',1,16,'none','white'],['110vw','100%',1,15,'none','transparent'],['110vw','100%',1,15,'none','transparent']]) 
    const [bgcolor,setbgcolor]=useState('#C8DBE9') 

    const [linealphe,setlinealphe]=useState(1)
  
    let navigate =useNavigate();
  let location =useLocation()
    let w=window.innerWidth
    let h=window.innerHeight
    let wpradio=1196/621
    const cardtop=-h*.12

    useEffect(()=>{
        let wph=w*wpradio
        let wpt=(h-wph)/2+h*.1
      
            

        setwptop(wpt)
        setcardbg(1)
       

    },[])

    



    const bindqatwodrag = useGesture({
        onDragStart: ({down,movement: [mx] }) => {
        
          if(down){
              
              
            tempx=mx
                
           }
      },
    
      onDrag: ({ down, movement: [mx] }) => {
          
        if (!down) {
    
     
    
        }
    
        if (down) {
         
    
           // console.log('drag mov'+(tempx-mx))
           
               if(candrag){
                 
                  if(tempx-mx>=9){
                       // console.log('left')
                        candrag=false
                        if(targetcard+1<3){
                          targetcard+=1
                          resetcardpose(targetcard)
                        }
    
                  }else if(tempx-mx<=-9){
                       // console.log('right')
                        candrag=false
                        if(targetcard-1>=0){
                          targetcard-=1
                          resetcardpose(targetcard)
                        }
                  }
              }
     
        }
    
         
      },onDragEnd:({ down, movement: [mx]})=>{
          
            
         
    
           candrag=true
       }
      });


      function resetcardpose(targetcard){

        let wppose=[[0,1,1,16,'none'],[w,1,.9,15,'none'],[w,1,.9,15,'none']]
         if(targetcard==0){
             
             wppose=[[0,'0%',.9,16,'none','white'],[w*1.1,'100%',1,15,'flex','transparent'],[w*1.1,'100%',1,15,'flex','transparent']]
             setbgcolor('#C8DBE9') 
             setlinealphe(1)
         }else if(targetcard==1){

            wppose=[[-w*1.1,'0%',1,15,'none','transparent'],[0,'100%',.9,16,'flex','white'],[w*1.1,'100%',1,15,'flex','transparent']]
            setbgcolor('#CACACA') 
            setlinealphe(0)
         }else if(targetcard==2){
              wppose=[[-w*1.1,'0%',1,15,'none','transparent'],[-w*1.1,'100%',1,15,'flex','transparent'],[0,'100%',.9,16,'flex','white']]
              setbgcolor('#CACACA') 
              setlinealphe(0)
         }

       
        
         setwppose(wppose)
      }

      function backhome(){
        // navigate('/',{state:{id:0,nick:''}})
        
        //  window.location.replace('/')
          navigate('/',{state:{id:0,nick:''}})
         
       }



    return <div>

                <div className='noselect' style={{width:'100vw',height:'100vh',position:'absolute',justifyContent:'center',alignItems:'center',display:'flex',opacity:cardbg,transition:`all 1s`,backgroundColor:bgcolor}}>

                         <div  tabIndex={-1} {...bindqatwodrag()}   style={{width:'100vw',height:'100vh',position:'absolute',justifyContent:'center',alignItems:'center',display:'flex',opacity:cardbg,transition:`all 1s`}}>
                                    <div style={{ width:'100vw',height:'100vh',position:'absolute',justifyContent:'center',alignItems:'center',display:'flex',opacity:1,transition:`all ${wppose[0][2]}s ease-in-out`,top:'-14vh',overflow:'hidden',left:wppose[0][0],zIndex:wppose[0][3]}} >
                                       <div style={{boxShadow: '-10px -10px -10px rgba(0, 0, 0, 0.5)',width:'100vw',height:'100vh',position:'absolute',justifyContent:'center',alignItems:'center',display:'flex',opacity:1,borderRadius:'12vw',top:'0vw',overflow:'hidden',left:0}} >

                                                <img 
                                                src={`${hostloca}Assets/wpbg5.jpg`} 
                                                style={{
                                                width:'100%' , // Set image width to screen width
                                                position: 'absolute',
                                                top: wptop, // Adjust this to position correctly
                                                left: 0, // Center the image horizontally
                                                filter: 'grayscale('+wppose[0][1]+')'
                                                }}
                                                /> 
                                                  <img 
                                                src={`${hostloca}Assets/wallpaper5.jpg`} 
                                                style={{
                                                width:'100%' , // Set image width to screen width
                                                position: 'absolute',
                                                opacity:0,
                                                top: wptop, // Adjust this to position correctly
                                                left: 0, // Center the image horizontally
                                                filter: 'grayscale('+wppose[0][1]+')'
                                                }}
                                                /> 
                                          </div>
                                          <div className='noselect' style={{width:'100vw',height:'100vh',position:'absolute',justifyContent:'center',alignItems:'center',display:wppose[0][4],opacity:0.4,top:'0vw',backgroundColor:'black',left:0,}} >
                                         <span className='textnormal' style={{fontSize:'2.8vw',letterSpacing:'.5vw',top:'55vh',paddingLeft:'0vw',position:'absolute',fontWeight:400,color:'white'}}>完成游戏关卡解锁新壁纸</span>  
                                            </div>
                                    </div>
                                    
                                    <div  style={{width:'100vw',height:'100vh',position:'absolute',justifyContent:'center',alignItems:'center',display:'flex',opacity:1,transition:`all ${wppose[1][2]}s ease-in-out`,borderRadius:'12vw',top:'-14vh',overflow:'hidden',left:wppose[1][0],zIndex:wppose[1][3]}} >
                                             
                                       <div  style={{boxShadow: '-10px -10px -10px rgba(0, 0, 0, 0.5)',width:'100vw',height:'100vh',position:'absolute',justifyContent:'center',alignItems:'center',display:'flex',opacity:1,borderRadius:'12vw',top:'0vw',overflow:'hidden',left:0}} >
                                                <img 
                                                src={`${hostloca}Assets/wpbg2.jpg`} 
                                                style={{
                                                width:'100%' , // Set image width to screen width
                                                position: 'absolute',
                                                top: wptop, // Adjust this to position correctly
                                                left: 0, // Center the image horizontally
                                                filter: 'grayscale('+wppose[1][1]+')'
                                                }}
                                                /> 
                                                 <img 
                                                src={`${hostloca}Assets/wallpaper2.jpg`} 
                                                style={{
                                                width:'100%' , // Set image width to screen width
                                                position: 'absolute',
                                                opacity:0,
                                                top: wptop, // Adjust this to position correctly
                                                left: 0, // Center the image horizontally
                                                filter: 'grayscale('+wppose[0][1]+')'
                                                }}
                                                /> 
                                         </div>
                                         <div className='noselect' style={{width:'100vw',height:'100vh',position:'absolute',justifyContent:'center',alignItems:'center',display:wppose[1][4],opacity:0.4,top:'0vw',backgroundColor:'black',left:0,}} >
                                         <span className='textnormal' style={{fontSize:'2.8vw',letterSpacing:'.5vw',top:'55vh',paddingLeft:'0vw',position:'absolute',fontWeight:400,color:'white'}}>完成游戏关卡解锁新壁纸</span>  
                                            </div>
                                            
                                    </div>
                                    
                                    <div style={{width:'100vw',height:'100vh',position:'absolute',justifyContent:'center',alignItems:'center',display:'flex',opacity:1,transition:`all ${wppose[2][2]}s ease-in-out`,borderRadius:'12vw',top:'-14vh',overflow:'hidden',left:wppose[2][0],zIndex:wppose[2][3]}} >
                                        <div style={{boxShadow: '-10px -10px -10px rgba(0, 0, 0, 0.5)',width:'100vw',height:'100vh',position:'absolute',justifyContent:'center',alignItems:'center',display:'flex',opacity:1,borderRadius:'12vw',top:'0vw',overflow:'hidden',left:0}} >
                                                 <img 
                                                src={`${hostloca}Assets/wpbg0.jpg`} 
                                                style={{
                                                width:'100%' , // Set image width to screen width
                                                position: 'absolute',
                                                top: wptop, // Adjust this to position correctly
                                                left: 0, // Center the image horizontally
                                                filter: 'grayscale('+wppose[2][1]+')'
                                                }}
                                                /> 
                                                 <img 
                                                src={`${hostloca}Assets/wallpaper0.jpg`} 
                                                style={{
                                                width:'100%' , // Set image width to screen width
                                                position: 'absolute',
                                                opacity:0,
                                                top: wptop, // Adjust this to position correctly
                                                left: 0, // Center the image horizontally
                                                filter: 'grayscale('+wppose[0][1]+')'
                                                }}
                                                /> 
                                            </div>
                                            <div className='noselect' style={{width:'100vw',height:'100vh',position:'absolute',justifyContent:'center',alignItems:'center',display:wppose[2][4],opacity:0.4,top:'0vw',backgroundColor:'black',left:0,}} >
                                            <span className='textnormal' style={{fontSize:'2.8vw',letterSpacing:'.5vw',top:'55vh',paddingLeft:'0vw',position:'absolute',fontWeight:400,color:'white'}}>完成游戏关卡解锁新壁纸</span>  
                                            </div>
                                    </div>
                        </div>






                             <div style={{width:'12vw',height:'3vw',position:'absolute',top:'87vh',display:'flex',alignItems:'center',justifyContent:'center',zIndex:32}}>

                                        <div style={{width:'3vw',height:'2vw',display:'flex',alignItems:'center',justifyContent:'center',padding:'1vw'}}>
                                                        <div className='textscore' style={{textAlign:'center',border:  '1px solid #ffffff',borderRadius:'50%',width:'60%',height:'60%',color:'white',lineHeight:'4vh',transition:`all .6s`,backgroundColor:wppose[0][5]}}>

                                                                
                                                        </div>

                                            </div>
                                        <div style={{width:'3vw',height:'2vw',display:'flex',alignItems:'center',justifyContent:'center',padding:'1vw'}}>
                                                        <div className='textscore' style={{textAlign:'center',border:   '1px solid #ffffff',borderRadius:'50%',width:'60%',height:'60%',color:'white',lineHeight:'4vh',transition:`all .6s`,backgroundColor:wppose[1][5]}}>

                                                                
                                                        </div>

                                            </div>
                                        <div style={{width:'3vw',height:'2vw',display:'flex',alignItems:'center',justifyContent:'center',padding:'1vw'}}>
                                                                <div className='textscore' style={{textAlign:'center',border: '1px solid #ffffff',borderRadius:'50%',width:'60%',height:'60%',color:'white',lineHeight:'4vh',transition:`all .6s`,backgroundColor:wppose[2][5]}}>

                                                                    
                                                            </div>

                                        </div>

                             </div>






                        <img className='elementabsolute' src={hostloca+'Assets/wpline.png'} style={{boxShadow: '-10px -10px -10px rgba(0, 0, 0, 0.5)',width:'46vw',top:'92vh',zIndex:20,transition:`all 1s`,opacity:linealphe}}/>   

                 <div onClick={()=>backhome()} className='btnnohightline'  style={{width:'7vw',height:'7vw',position:'absolute',top:'3vh',left:'6vw',opacity:1,zIndex:20}}>

                    <img  src={hostloca+'Assets/back.png'} style={{width:'100%'}}/> 
                        
                    </div>

            </div>




    </div>

}